import { connect } from 'react-redux';
import {
  getDashboardEnteredLegendName,
  getDashboardEvents,
} from '../../../../../reducers/analyticsApp';
import { enterLegendName } from '../../../../../actions/dashboards/events';
import EventLegend from '../../../../../components/dashboards/cards/builder/event/EventLegend';

const mapStateToProps = (state, { unit }) => {
  const events = getDashboardEvents(state, unit.id);
  const enteredLegendName = getDashboardEnteredLegendName(state, unit.id);

  return {
    events,
    enteredLegendName,
  };
};

const mapDispatchToProps = (dispatch, { unit }) => ({
  onChangeLegendName: (name) => dispatch(enterLegendName(unit.id, name)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EventLegend);
